import { Observable } from 'rxjs';
import { LocationResponse } from '../models/location-response.model';
import { LocationRequest } from '../models/location-request.model';
import { SchedulesRequest } from '../models/schedules-request';
import { SchedulesResponse } from '../models/schedules-response';

export abstract class LocationsRepository {
    abstract findLocations(
        locationRequest: LocationRequest,
    ): Observable<LocationResponse>;
    abstract findSchedules(
        locationRequest: SchedulesRequest,
    ): Observable<SchedulesResponse>;
}
